interface WorldAndCheckmarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WorldAndCheckmarkSVG = ({ color, style }: WorldAndCheckmarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="52"
    viewBox="0 0 40 52"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17727)">
      <path
        d="M3.7085 32.1633H36.2914"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 26.6896V32.1848"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 48.0887V32.1633"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.169 16.4749C36.1391 19.966 39.3908 25.7306 39.3908 32.2172V32.1848C39.3908 42.7982 30.7122 51.3966 19.9999 51.3966C9.28752 51.3966 0.608887 42.7982 0.608887 32.1848C0.608887 25.7414 3.80628 20.0307 8.72199 16.5396"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7123 24.5993C10.0272 26.8189 9.60303 29.4264 9.60303 32.4865"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.2876 24.5993C29.9728 26.8189 30.3969 29.4264 30.3969 32.4865"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6001 48.4119C27.3842 45.5781 30.3967 40.6324 30.3967 32.5081"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3886 48.4012C12.6154 45.5673 9.61377 40.6216 9.61377 32.5081"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5714 43.811C29.679 42.2487 26.1445 40.4277 20.0107 40.4277"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.29785 43.9296C10.1576 42.3456 13.7138 40.4277 19.9999 40.4277"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2812 13.501L19.7717 15.6884L23.3498 11.346"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M30.4295 3.72815C24.0021 4.4824 19.9999 0.818909 19.9999 0.818909C19.9999 0.818909 16.0086 4.4824 9.57036 3.72815C9.57036 3.72815 7.55839 20.6018 19.9999 24.2437C32.4306 20.6018 30.4295 3.72815 30.4295 3.72815Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17727">
        <rect width="40" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default WorldAndCheckmarkSVG;
